const OptionalTime = (val) => {
    let valid = false;
    let error = null;

    if (val) {
        const regex = /^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;
        if (regex.test(val) === false) {
            valid = false;
            error = 'Please enter a valid time';
        } else {
            valid = true;
        }
    } else {
        valid = false;
    }

    return [
        valid,
        error,
    ]
}

export default OptionalTime;